import React from "react";
import { Container, Box } from "@mui/material";
import { MapPin, ShoppingCart, Codesandbox, Phone, Clock } from "react-feather";

const Footer = () => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        pt: 2,
        pb: 3,
        backgroundColor: "#e1e2e2",
        borderColor: "#cbcbcb75",
      }}
      id="contact"
    >
      <Container maxWidth="lg" sx={{ mt: 1 }}>
        <Box className="flex flex-col md:flex-row justify-between items-start md:items-start-3 gap-6">
          Данс : Хаан банк 5166337961 Цагаанхүү (Гүйлгээний утга дээр Захиалсан
          барааны мэдээлэл, Facebook нэр, Утасны дугаар оруулаарай) Манай хаяг :
          Баянзүрх дүүрэг, ИХ НАЯД ЗҮҮН ӨНДӨР 5давхар 503тоот Лавлах утас :
          9510-0713 Хүргэлтээр авах бол 24~48 цагийн дотор хүргэлт хийнэ.
          Хүргэлтийн лавлах утас : 95100713 Ажлын цаг - 10:00~18:00 хүртэл
          ажиллана. Ням гарагт амарна). Өдөрт ирэх дуудлага их байдаг ба давхар
          дуудлагатай үед дуудаж байгаа дохио өгдөг тул та ахин залгаарай.
        </Box>

        <Box
          variant="body2"
          className="text-center text-[11px] font-medium text-black uppercase mt-2"
        >
          ©2025 Зохиогчийн эрх хуулиар хамгаалагдсан.
        </Box>
      </Container>
    </Container>
  );
};

export default Footer;
